/**
 * StorePickerModal 用的純函式：搜尋、篩選、最近使用（localStorage）
 * 全無 React dependency — 方便 unit test 與 mutation test
 */

export const RECENT_STORES_KEY = 'cvs_recent_stores_v1'
export const RECENT_STORES_LIMIT = 5

const lower = (s) => (s == null ? '' : String(s).toLowerCase())

export const normalizeQuery = (q) => lower(q).trim()

export const matchStore = (store, query) => {
  const q = normalizeQuery(query)
  if (!q) return true
  return (
    lower(store.store_name).includes(q) ||
    lower(store.address).includes(q) ||
    lower(store.store_id).includes(q)
  )
}

export const filterStores = (stores, { query, city, town }) => {
  if (!Array.isArray(stores)) return []
  return stores.filter((s) => {
    if (city && s.city !== city) return false
    if (town && s.town !== town) return false
    return matchStore(s, query)
  })
}

export const groupByCity = (stores) => {
  const map = new Map()
  for (const s of stores || []) {
    if (!s?.city) continue
    if (!map.has(s.city)) map.set(s.city, [])
    map.get(s.city).push(s)
  }
  return map
}

export const uniqueTowns = (stores, city) => {
  if (!Array.isArray(stores)) return []
  const set = new Set()
  for (const s of stores) {
    if (city && s.city !== city) continue
    if (s?.town) set.add(s.town)
  }
  return [...set]
}

const safeWindow = () => (typeof window === 'undefined' ? null : window)

export const getRecentStores = () => {
  const w = safeWindow()
  if (!w) return []
  try {
    const raw = w.localStorage.getItem(RECENT_STORES_KEY)
    if (!raw) return []
    const arr = JSON.parse(raw)
    if (!Array.isArray(arr)) return []
    return arr.slice(0, RECENT_STORES_LIMIT)
  } catch {
    return []
  }
}

export const saveRecentStore = (store) => {
  const w = safeWindow()
  if (!w || !store?.store_id) return
  const slim = {
    store_id: store.store_id,
    store_name: store.store_name,
    address: store.address,
    city: store.city,
    town: store.town,
  }
  const prev = getRecentStores().filter((s) => s.store_id !== store.store_id)
  const next = [slim, ...prev].slice(0, RECENT_STORES_LIMIT)
  try {
    w.localStorage.setItem(RECENT_STORES_KEY, JSON.stringify(next))
  } catch {
    // localStorage full / quota — swallow
  }
}

export const clearRecentStores = () => {
  const w = safeWindow()
  if (!w) return
  w.localStorage.removeItem(RECENT_STORES_KEY)
}
